<template>
	<v-dialog
		v-model="open"
		v-if="open && product"
		:content-class="`discount-dialog`"
	>
		<v-layout column class="kiosk-modal discount-layout">
			<div class="black-background">
				<v-btn icon class="close-btn" @click="onClose">
					<img  alt="" class="close-image" src="../../../../../static/tid100/images/icons/x-close.svg"/>
				</v-btn>
				<v-layout column wrap justify-space-between class="dialog-body-wrapper">
					<v-layout column class="discount-dialog-body">
						<div class="discount-title">{{ $t('utilityComponents.productAsCompensationCRMModule.congrats') }}</div>
						<div class="discount-subtitle">{{ $t('utilityComponents.productAsCompensationCRMModule.youHaveWon') }}</div>
						<div class="discount-product">{{  product.name }}</div>
						<div class="discount-price">
							{{ awardVoucherItem.discountRate === 100 ?
							$t('utilityComponents.productAsCompensationCRMModule.gratis') :
							$t('utilityComponents.productAsCompensationCRMModule.discountPrice', { percent: awardVoucherItem.discountRate}) }}
						</div>
					</v-layout>
					<img class="product-as-reward-image" :src="getProductImage(product)"/>
					<v-layout column wrap class="discount-dialog-footer">
						<div class="discount-price-section">
							<div class="discount-new-price">{{ awardVoucherItem.discountRate === 100 ? $t('utilityComponents.productAsCompensationCRMModule.free') : awardVoucherItem.discountRate + "%" }}</div>
						</div>
						<v-btn @click="takeAward(product)"
								:ripple="false"
								class="redeem-discount green-btn"
								primary
								flat>
							{{ $t('utilityComponents.productAsCompensationCRMModule.redeemDiscount') }}
						</v-btn>
						<v-btn @click="onClose"
								:ripple="false"
								class="not-now"
								primary
								flat>
							{{ $t('utilityComponents.productAsCompensationCRMModule.notNow') }}
						</v-btn>
						<div class="unredeemed-discount">{{ $t('utilityComponents.productAsCompensationCRMModule.unredeemedDiscount') }}</div>
					</v-layout>
				</v-layout>
			</div>
		</v-layout>
	</v-dialog>
</template>

<script>
import {voucherProductAddToCart} from "../../../../helper/VoucherProductHelper";

export default {
	name: "VoucherLandingPageDialog-gt2",
	props: ["show", "onClose", "product", "awardVoucherItem", "getProductImage"],
	computed: {
		open: {
			get() {
				return this.show;
			},
			set() {
				this.onClose();
			}
		}
	},
	methods: {
		async takeAward(product) {
			this.$store.commit("SET_VOUCHER_PRODUCT_ADD_TO_CART", {productId: product.id, voucherId: this.awardVoucherItem.voucherId});
			this.onClose();
			await voucherProductAddToCart(this);
		}
	}
};
</script>

<style lang="scss" scoped>
.v-dialog__content:has(.discount-dialog) {
	z-index: 9999 !important;
}
/deep/ .discount-dialog {
	width: 100%;
	height: 100%;
	margin: 0;
	max-height: 100%;
	.discount-layout, .black-background {
		height: 100%;
		padding-bottom: 0;
	}
	.discount-layout {
		.close-btn {
			position: absolute;
			top: 0;
			right: 0;
		}
		.dialog-body-wrapper {
			height: 100%;
		}
		.discount-dialog-body {
			color: #FFFFFF;
			padding: 100px 25px 0;
			text-align: center;
			font-weight: bold;
			.discount-title {
				font-size: 28px;
				line-height: 1;
			}
			.discount-subtitle, .discount-product, .discount-price {
				font-size: 20px;
				line-height: 34px;
			}
			.discount-price {
				color: #FFD800;
			}
		}
		.discount-dialog-body, .discount-dialog-footer {
			flex: 0 1 auto;
		}
		.discount-dialog-footer {
			margin: 0 15px;
			.redeem-discount {
				height: 60px;
				font-size: 22px;
			}
			.not-now {
				height: 60px;
				border: 2px solid #ffffff;
				color: #ffffff;
				margin: 15px 0 0;
				font-size: 22px;
				font-family: Dispatch-Bold;
			}
			.unredeemed-discount {
				color: white;
				font-size: 14px;
				line-height: 18px;
				text-align: center;
				margin: 15px 0;
			}
			.discount-price-section {
				display: flex;
				justify-content: flex-end;
				margin-bottom: 15px;
				.discount-regular-price {
					background-color: #333333;
					font-size: 20px;
					color: #7B7B7B;
					padding: 7px 15px;
					line-height: 1;
					text-decoration: line-through;
					font-weight: bold;
				}
				.discount-new-price {
					background-color: #FFD800;
					font-size: 20px;
					font-weight: bold;
					padding: 7px 15px;
					line-height: 1;
					text-transform: uppercase;
				}
			}
		}
	}
	.product-as-reward-image {
		width: 100%;
		max-height: 300px;
	}
}
</style>